/* eslint-disable eqeqeq */
import {
  Container,
  Grid,
  Link,
  Slide,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppBaseScreen from "../../components/AppBaseScreen";
import { whithdrawTheme, styles } from "./theme";
import { LinearProgress } from "@mui/material";

import { ACTIVITY_DETAIL, ACTIVITY_META, EVENTS, fiatVendors, paymentOptions } from "../../utils/constants";
import {
  findSymbol,
  formatNumber,
  getBackTitles,
  getCurrentTitles,
  getSymbol,
  isBlockedUser,
  isKycVerified,
} from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import KycPending from "./components/KycPending";
import KycBlocked from "./components/KycBlocked";
import { ONBOARDING_GUIDE_LINK } from "../../utils/config";
import KyconHold from "./components/KyconHold";
import { connectBank, getDashboardData, getPockytConnectedBanks } from "../../store/actions";
import Step1 from "./components/common-steps/Step1";
import Step2 from "./components/common-steps/Step2";
import RenderSteps from "./components/withdraw-options/render";
import { logEvent } from "../../store/api";
import { isIOS } from "react-device-detect";
import { SET_PAYMENT_OPTION } from "../../store/actions/actionTypes";
import AppScreenLoader from "../../components/AppScreenLoader";

const Withdraw = () => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({
    address: "",
    amount: "",
  });
  const { t } = useTranslation();
  const dashboardData = useSelector(({ dashboard }) => dashboard);
  const bankFlag = useSelector(({ transfer }) => transfer.connectBank);
  const symbols = useSelector(getSymbol);
  const account = useSelector(({ Auth }) => Auth?.account);
  const skip = useSelector(({ transfer }) => transfer.skip);
  const user = useSelector(({ Auth }) => Auth.user);
  const [active, setActiveValue] = useState(0);
  const [amount, setAmount] = useState("");
  const bankList = useSelector(({ transfer }) => transfer.connectedBanks);
  const [payment, setPayment] = useState("");
  const navigate = useNavigate();
  const [showKyt, setShowKyt] = useState(false);
  const [showKytBlocked, setShowKytBlocked] = useState(false);
  const [showKycReview, setShowKycReview] = useState(false);
  const [caluclate, setCalculate] = useState(25);
  const location = useLocation();
  const [optionSelectMode, setOptionSelectMode] = useState("country-currency");
  const [cryptoCurrency, setCryptoCurrency] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fiatOption, setFiatOption] = useState(null);
  const [  destinationRecord, setDestinationRecord] = useState(null);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (user && user.kycStatus) {
      // eslint-disable-next-line eqeqeq
      if (user && user.kycStatus && isBlockedUser(user.kycStatus)) {
        setShowKytBlocked(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus == 4
      ) {
        setShowKycReview(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        !isKycVerified(user)
      ) {
        setShowKyt(true);
      }
    }
    // get data
    dispatch(getDashboardData());
    dispatch(getPockytConnectedBanks());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const setActive = (val) => {
    setActiveValue(val);
  };
  useEffect(() => {
    let query = '';
    // if (payment) query = `/${payment}`;
    if (active == 1 || active == 2) {
      query = '';
    }
    if(active === 1 || active === 0) {
      setCryptoCurrency(null);
    }
    navigate(`/withdraw/${active}${query}`);
    //for crypto
    if (active === 3 && payment === paymentOptions.crypto && user && user.kycStatus) {
      // eslint-disable-next-line eqeqeq
      if (isBlockedUser(user.kycStatus)) {
        setShowKytBlocked(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus == 4
      ) {
        setShowKycReview(true);
      } else if (
        // eslint-disable-next-line eqeqeq

        !isKycVerified(user)
      ) {
        setShowKyt(true);
      }
    }
    // for non crypto
    if (active === 2 && fiatVendors.includes(payment) && user && user.kycStatus) {
      // eslint-disable-next-line eqeqeq
      if (isBlockedUser(user.kycStatus)) {
        setShowKytBlocked(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        user.kycStatus == 4
      ) {
        setShowKycReview(true);
      } else if (
        // eslint-disable-next-line eqeqeq
        !isKycVerified(user)
      ) {
        setShowKyt(true);
      }
    }
    if (payment === paymentOptions.masspay) {
      setCalculate(100 / 6);
    } else if ([paymentOptions.pockyt, paymentOptions.xbd, paymentOptions.cj].includes(payment)) {
      if (bankFlag) {
        setCalculate(100 / 5);
      } else setCalculate(100 / 4);
    } else if (paymentOptions.crypto2 === payment) {
      setCalculate(100 / 3);
    } else if (paymentOptions.crypto3 === payment) {
      setCalculate(100 / 4);
    } else {
      setCalculate(25);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, bankFlag]);

  const [pendingStep, setPendingStep] = useState(false);

  const handlePaymentMethod = (ev, value, currency) => {
    ev.preventDefault();
    setLoading(true);

    setPayment(value);
    dispatch({ type: SET_PAYMENT_OPTION, payload: value });
    dispatch(connectBank(false));

    logEvent({
      current: EVENTS.WITHDRAWAL.TRANSFER_METHOD,
      activity: ACTIVITY_DETAIL.WITHDRAWAL.TRANSFER_METHOD,
      meta: {
        data: {
          method: value?.toLowerCase(),
          pathname: location.pathname,
          source: ACTIVITY_META.WITHDRAWAL.TRANSFER_METHOD
        }
      }
    });

    // If currency is needed, update and wait for state update
    if (currency) {
      setCryptoCurrency(currency);
      setPendingStep(true);
    } else {
      // If no currency is involved, proceed immediately
      setActive((prev) => prev + 1);
    }
    setLoading(false);
  };

  // Move to the next step only if cryptoCurrency is needed and has updated
  useEffect(() => {
    if (pendingStep && cryptoCurrency) {
      setActive((prev) => prev + 1);
      setPendingStep(false);
    }
  }, [cryptoCurrency, pendingStep]);


  const handleAmountChange = (val, err) => {
    setAmount(val.toString());
    setErrors({ ...errors, ...err });
  };



  const handleVerification = () => {
    setShowKyt(false);
    navigate("/verification");
  };

  const handleActive = (active) => {
    if (active === 1) {
      if (amount <= 0) {
        setErrors({ amount: t("invalidAmount") });
        return;
      }

      if (
        parseFloat(amount.toString()) >
        parseFloat(dashboardData.balance.toString())
      ) {
        setErrors({
          amount:
            "Amount should be lower than or equal to the available balance",
        });
        return;
      }
      if (parseFloat(amount.toString()) < dashboardData.payoutMinimumTransferable) {
        setErrors({ amount: `${t('AmountEqual')} $${ dashboardData.payoutMinimumTransferable}` });
        return;
      }
      logEvent({
        current: EVENTS.WITHDRAWAL.TRANSFER_BEGIN,
        activity: ACTIVITY_DETAIL.WITHDRAWAL.TRANSFER_BEGIN,
        meta: {
          data: {
            amount: amount,
            max: Number(amount) === Number(dashboardData.balance),
            pathname: location.pathname,
            source: ACTIVITY_META.WITHDRAWAL.TRANSFER_BEGIN
          }
        }
      });
    }

    setActive(active);
  }

  const handleSetActive = () => {
    let tab = active;
    while (skip.includes(tab)) {
      tab = tab - 1;
    }
    tab = tab - 1;
    setActive(tab)
  }

  if (loading) {
    return <AppScreenLoader />
  }
  return (
    <AppBaseScreen
      headerTitle1={t("homePage.withdraw")}
      headerSubTitle1={getCurrentTitles(
        active,
        payment,
        t,
        bankFlag || bankList?.length === 0,
        optionSelectMode,
      )}
      navigate={true}
      navigatePath={!active ? "/home" : handleSetActive}
      cancel={() => navigate("/home")}
      backText={!active ? "Home" : getBackTitles(active - 1, skip, payment, t, bankFlag || bankList?.length === 0)}
    >
      <KycPending
        active={active}
        handleVerification={handleVerification}
        setShowKyt={setShowKyt}
        showKyt={showKyt}
        payment={payment}
      />
      <KycBlocked
        handleVerification={handleVerification}
        setShowKytBlocked={setShowKytBlocked}
        showKytBlocked={showKytBlocked}
      />
      <KyconHold setShowKyt={setShowKycReview} showKyt={showKycReview} />
      <ThemeProvider theme={whithdrawTheme}>
        <Grid container>
          <Grid item xs={12} sx={{ marginTop: 0, padding: 0 }}>
            <LinearProgress variant="determinate" value={caluclate * active} />
          </Grid>
          <Grid item xs={12} md={12} xl={12} lg={12} minHeight={isIOS ? '55vh' : '67vh'}>
            {active === 0 && (
              <Slide in={true} direction="left">
                <Container maxWidth="xs" disableGutters>
                  <Step1 active={active} amount={amount} dashboardData={dashboardData} errors={errors} handleActive={handleActive} handleAmountChange={handleAmountChange} />
                </Container>
              </Slide>
            )}

            {active === 1 && (
              <Slide in={true} direction="left">
                <Container maxWidth="xs" disableGutters>
                  <Step2 handlePaymentMethod={handlePaymentMethod} payment={payment} amount={amount} styles={styles} />
                </Container>
              </Slide>
            )}
            <Slide in={true} direction="left">
              <Container maxWidth="xs" disableGutters>
                <RenderSteps active={active} amount={amount} setActive={setActive} setOptionSelectMode={setOptionSelectMode} setShowKyt={setShowKyt} setShowKytBlocked={setShowKycReview} type={payment} cryptoCurrency={cryptoCurrency} fiatOption={fiatOption} setFiatOption={setFiatOption} destinationRecord={destinationRecord} setDestinationRecord={setDestinationRecord}/>
              </Container>
            </Slide>
          </Grid>
          <Grid item xs={12} md={12}>
            <Container maxWidth="xs" disableGutters>
              {(payment === paymentOptions.crypto ? [1, 2] : payment === paymentOptions.crypto2 ? [1] : payment === paymentOptions.crypto3 ? [1, 2] : [1, 2, 3]).includes(active) && (
                <Box sx={{ height: "10vh", bottom: isIOS ? '4%' : 1, position: 'relative' }}>
                  <Typography color={"#D4D4D8"} fontWeight={400} fontSize={30}>
                  {findSymbol(symbols, account)} {formatNumber(amount)}
                  </Typography>
                  <Link
                    href={ONBOARDING_GUIDE_LINK + "/fee-schedule"}
                    target="_blank"
                    color={"#0088F5"}
                    fontSize={16}
                    fontWeight={500}
                  >
                    {t("Learn more about fees")}
                  </Link>
                </Box>
              )}
            </Container>
          </Grid>

        </Grid>
      </ThemeProvider>
    </AppBaseScreen>
  );
};

export default Withdraw;
